<template>
  <div>
    <v-toolbar dark color="primary">
      <v-toolbar-title class="white--text">wots nu?</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$router.push('/home')"> X </v-btn>
    </v-toolbar>
  <v-flex xs12 sm6 offset-sm3 md6 offset-md3>
    <v-card>
      <v-flex xs12 v-if="hasImage">
        <v-textarea label="Caption your photo" v-model="caption"></v-textarea>
      </v-flex>
      <v-flex xs12 class="text-xs-right" v-if="hasImage">
        <v-btn v-if="hasImage" color="success" @click="saveImage">Post</v-btn>
      </v-flex>
      <image-uploader
        id=""
        :maxWidth="1536"
        :maxHeight="1536"
        :quality="0.8"
        :autoRotate=true
        outputFormat="blob"
        :preview=true
        :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
        @input="setImage"
        @onUpload="startImageResize"
        @onComplete="endImageResize"
      ></image-uploader>
    </v-card>
  </v-flex>
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Uploading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {ImageUploader} from 'vue-image-upload-resize'
const fb = require('../firebase')
const uuidv1 = require('uuid/v1')

export default {
  name: 'ImageUpload',
  data () {
    return {
      hasImage: false,
      dialog: false,
      filename: '',
      caption: ''
    }
  },
  computed: {
    groupId: function () {
      return this.$route.params.id
    }
  },
  components: {
    ImageUploader
  },
  methods: {
    setImage: function (file) {
      this.hasImage = true
      this.image = file
    },
    startImageResize: function () {
      this.dialog = true
    },
    endImageResize: function () {
      this.dialog = false
    },
    saveImage: function () {
      this.dialog = true
      this.filename = uuidv1() + '.jpg'
      fb.storage.ref('images/' + this.filename).put(this.image)
        .then((snapShot) => {
          this.dialog = false

          fb.postsCollection.add({
            asset: snapShot.ref.fullPath,
            caption: this.caption,
            group: fb.groupsCollection.doc(this.groupId),
            created: new Date(),
            comments: [],
            user: fb.usersCollection.doc(fb.auth.currentUser.uid)
          })
            .then(() => {
              this.$router.push('/home')
            })
        })
        .catch((error) => {
          this.dialog = false
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue